import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import WebDevelopment from './pages/WebDevelopment';
import ITConsulting from './pages/ITConsulting';
import Software from './pages/Software';
import AppDevelopment from './pages/AppDevelopment';
import RealEstate from './pages/RealEstate';
import Investing from './pages/Investing';
import AiServices from './pages/AiServices';
import Payment from './pages/Payment';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        {/* Tech Services */}
        <Route path="/web-development" element={<WebDevelopment />} />
        <Route path="/it-consulting" element={<ITConsulting />} />
        <Route path="/software" element={<Software />} />
        <Route path="/app-development" element={<AppDevelopment />} />
        {/* Investment Services */}
        <Route path="/real-estate" element={<RealEstate />} />
        <Route path="/investing" element={<Investing />} />
        {/* AI Services */}
        <Route path="/ai-services" element={<AiServices />} />
        {/* Payments */}
        <Route path="/payment" element={<Payment />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;